import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module'; //rutas del servicio
import { AuthModule } from './auth/auth.module'; //todos los componentes de la carpeta auth
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { environment } from '../environments/environment.dev';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { NgModule } from '@angular/core';
import { NopagefoundComponent } from './nopagefound/nopagefound.component';
import { OnboardingModule } from './onboarding/onboarding.module';
import { PagesModule } from './pages/pages.module'; //todos los componentes de la carpeta pages
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { ServiceWorkerModule } from '@angular/service-worker';
import { VerificacionDocumentosModule } from './verificacion-documentos/verificacion-documentos.module';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDialogModule} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatNativeDateModule} from '@angular/material/core';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { SharedModule } from './shared/shared.module';
import { InscripcionConvenioModule } from './inscripcion-convenio/inscripcion-convenio.module';


import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CacheWebInterceptor } from './interceptors/cache-web.interceptor';

@NgModule({
  declarations: [
    AppComponent,
    NopagefoundComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    PagesModule,
    AuthModule,
    OnboardingModule,
    VerificacionDocumentosModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
    MatTableModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatButtonModule,
    MatInputModule,
    MatExpansionModule,
    MatDialogModule,
    MatNativeDateModule ,
    Ng2SearchPipeModule,
    CarouselModule,
    SharedModule,
    InscripcionConvenioModule,

  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheWebInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
